export const GET_REPORT_TYPES_QUERY = `
  query GetReportTypes($where: report_types_bool_exp = {}) {
    report_types(where: $where, order_by: { created_at: desc }) {
      id
      report_type_name
      report_type_description
      report_type_status
      company_id
      report_type_tags
      created_at
      updated_at
      company {
        id
        name
      }
    }
  }
`;

export const GET_REPORT_TYPE_BY_ID_QUERY = `
  query GetReportTypeById($id: Int!) {
    report_types_by_pk(id: $id) {
      id
      report_type_name
      report_type_description
      report_type_status
      company_id
      report_type_tags
      created_at
      updated_at
      company {
        id
        name
      }
    }
  }
`;
